<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <button v-if="selected" class="selected">
    <slot />
  </button>
  <button v-else :disabled="disabled" :title="title" :class="{outstanding: outstanding, shadow: shadow, red: red, orange: orange}">
    <slot />
  </button>
</template>

<script setup>
// eslint-disable-next-line
const props = defineProps({
  disabled: {type: Boolean, default: false},
  outstanding: {type: Boolean, default: false},
  selected: {type: Boolean, default: false},
  title: {type: String, default: ""},
  red: {type: Boolean, default: false},
  orange: {type: Boolean, default: false},
  shadow: {type: Boolean, default: true}
});
</script>

<style scoped>
button {
  min-width: 6rem;
  height: auto;
  box-sizing: border-box;
  white-space: nowrap;
  padding: 0.3em 0.6em 0.3em 0.6em; /* top right bottom left */
  margin: 0px;
  border: 0.5px solid var(--border-color-subtle); /* rgba(94, 94, 94, 1); */
  text-align: center;
  white-space: nowrap;
  text-shadow: none;
  color: #505050;
  background-color: #efedf1;
  cursor: pointer;
}
button.shadow {
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);
}
/* button:focus, */
button.outstanding {
  color: white;
  background-color: var(--brand-color);
  opacity: 1;
}
/* button[disabled]:focus, */
/* disabled: a grey just darker than the dialogs' background (#e4e4e4), not near-white, which
   read as an input field (2026-10-14) */
button[disabled],
button[disabled].outstanding {
  cursor: default;
  color: #9a9a9a;
  background-color: #d6d6d6;
  border: 1px solid rgba(0, 0, 0, 0.01);
}
/* button[disabled].shadow:focus, */
button[disabled].shadow,
button[disabled].outstanding.shadow {
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.06);
}
/* hover only where a click acts (DESIGN.md § 15): not a disabled or a selected button */
button:not(.outstanding):not([disabled]):not(.selected):hover {
  background-color: #d5d5d5;
}
button.outstanding:not([disabled]):hover {
  background-color: var(--brand-color);
  filter: brightness(0.80);
}
a:hover:not(:focus) {
  color: #505050; /* when it has focus but not hover, back to normal */
}
button.selected {
  cursor: pointer; /* selected isn't disabled (DESIGN.md § 15) */
  border: 1px solid rgba(207, 207, 207, 0);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0);
  text-shadow: none;
  font-weight: 700;
  background-color: transparent;
  letter-spacing: 0.03em;
  opacity: 1;
}
button.selected.shadow {
  text-shadow: rgb(0, 0, 0) 0px 0px 6px;
}
button.selected {
  color: var(--brand-color);
}
button.red,
button.red[disabled] {
  background-color: #dc2204;
  color: white;
}
button.orange,
button.orange[disabled] {
  background-color: var(--orange-on-light);
  color: white;
}
</style>
